module.exports = __webpack_public_path__ + "static/media/logoTeal.2d53acd6.png";